import {lighten} from '@material-ui/core/styles/colorManipulator';

export const styles = theme => ({
  paper: {
    width: '100%',
    marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  root: {
    paddingRight: theme.spacing.unit
  },
  sortableRow: {
    cursor: 'move'
  },
  row: {

  },
  highlight:
      theme.palette.type === 'light'
        ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
        : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
        },
  spacer: {
    flex: '1 1 100%'
  },
  search: {
    marginRight: theme.spacing.unit * 3,
    width: theme.spacing.unit * 80
  }
});

export default styles;
